<div>
  <netz-page-heading>TP5 (2021-2022)</netz-page-heading>
  <cca-summary [data]="summaryData()" />
</div>
